import { commentsReducer } from 'js/src/data/comments/comments-reducer';

/* MODULE EXPORTS */
export * from 'js/src/data/comments/comments-operations';
export * from 'js/src/data/comments/comments-selectors';
export * from 'js/src/data/comments/comments-types';
export * from 'js/src/data/comments/comments-actions';

export default commentsReducer;
